import { PropertyImage } from "../../data"
import { getProxiedImageUrl } from "../../../../common/image-proxy"

export default function TwoColumnThreeImageGrid({ images, direction, startIndex = 0, onClick, containerWidth = 700 }: {
    images: PropertyImage[];
    direction?: 'ltr' | 'rtl';
    startIndex?: number;
    onClick?: (imageIndex: number) => void;
    containerWidth?: number;
}) {
    const finalDirection = direction || 'ltr';

    // Don't render if we don't have enough images (need at least 1, max 3)
    if (images.length === 0) {
        return null
    }

    // Take only the first 3 images
    const displayImages = images.slice(0, 3)
    const [firstImage, ...remainingImages] = displayImages

    // Determine column order based on direction
    const singleImageColumn = (
        <div className="homerunner-gallery-two-column-three-main-image gallery-image-container h-full">
            <button
                type="button"
                className="appearance-none border-0 bg-transparent p-0 m-0 block w-full h-full text-left cursor-pointer"
                data-global-index={startIndex}
                onClick={() => onClick?.(startIndex)}
            >
                <img
                    src={getProxiedImageUrl(firstImage.url, 600, 450)}
                    alt={firstImage.caption || `Property image ${firstImage.position}`}
                    className="homerunner-gallery-image w-full h-full object-cover"
                />
                <div className="homerunner-gallery-hover-overlay gallery-hover-overlay"></div>
            </button>
        </div>
    )

    const twoImagesColumn = remainingImages.length > 0 ? (
        <div className="homerunner-gallery-two-column-three-thumbnails flex flex-col gap-2 h-full">
            {remainingImages.map((image, localIndex) => (
                <div key={localIndex} className="homerunner-gallery-two-column-three-thumbnail gallery-image-container flex-1 aspect-[16/9]">
                    <button
                        type="button"
                        className="appearance-none border-0 bg-transparent p-0 m-0 block w-full h-full text-left cursor-pointer"
                        data-global-index={startIndex + 1 + localIndex}
                        onClick={() => onClick?.(startIndex + 1 + localIndex)}
                    >
                        <img
                            src={getProxiedImageUrl(image.url, 300, 225)}
                            alt={image.caption || `Property image ${image.position}`}
                            className="homerunner-gallery-image w-full h-full object-cover"
                        />
                        <div className="homerunner-gallery-hover-overlay gallery-hover-overlay"></div>
                    </button>
                </div>
            ))}
        </div>
    ) : null

    return (
        <div className="homerunner-gallery-two-column-three-grid-container mb-2">
            <div className="homerunner-gallery-two-column-three-grid grid grid-cols-2 gap-2" style={{ maxWidth: containerWidth + 'px', margin: '0 auto' }}>
                {finalDirection === 'ltr' ? (
                    <>
                        {singleImageColumn}
                        {twoImagesColumn}
                    </>
                ) : (
                    <>
                        {twoImagesColumn}
                        {singleImageColumn}
                    </>
                )}
            </div>
        </div>
    )
}
